import templateStr from 'text!./templates/quick-quote-link.html';

export default [function () {
    return {
        replace: true,
        restrict: 'A',
        template: templateStr
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/quickquote/directives/QuickQuoteLink.js
// module id = 1226
// module chunks = 0